import { notBlank } from "@de-xima/xima-common-js-lang";

import { redirect } from "./Navigation.ts";

interface ICallBackData {
  code: number;
  location?: string;
  content?: string;
}

interface ICallbackMessageEvent extends MessageEvent {
  data: ICallBackData;
}

function backendCallbackListener(data: ICallBackData): void {
  const shouldRedirect = data.code === 302 || data.code === 303;
  if (shouldRedirect) {
    if (notBlank(data.location)) {
      redirect(data.location);
    } else {
      console.warn("No location for redirection given!");
    }
  }
}

export function callbackListener(event: ICallbackMessageEvent): void {
  if (window.location.origin === event.origin) {
    backendCallbackListener(event.data);
  } else {
    console.warn("Event origin is not allowed!", event.origin);
  }
}

export function findHref(htmlElement: HTMLElement): string | null | undefined {
  const href = htmlElement.getAttribute("href");
  if (notBlank(href)) {
    return href;
  }

  return htmlElement.dataset.href;
}
